module.exports = __webpack_public_path__ + "img/spring_0428.d9ed0216.png";